import { useNotification } from '@/containers'
import ImageOptimize from '../ImageOptimize'

export const HeaderLogo = () => {
  const { systemConfig } = useNotification()
  //systemConfig?.companyLogoHeaderMobile1 ||
  return (
    <div className='inline-flex'>
      <button className='flex gap-1 items-center outline-0'>
        <ImageOptimize
          loading='eager'
          priority
          className='h-full w-auto'
          alt={systemConfig?.websiteBrandName || 'Logo'}
          src={'/logo-mb.svg'}
          width={57}
          height={40}
        />
      </button>
    </div>
  )
}
